<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thêm mới tag</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col>
                                <b-form-group label="Mã tag:"
                                              label-for="code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text" id="code"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.tag.code.$model"
                                                  :state="$v.tag.code.$dirty? !$v.tag.code.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập mã tag
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Tên tag:"
                                              label-for="name"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="right"
                                              label-class="required">
                                    <b-form-input type="text" id="name"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.tag.name.$model"
                                                  :state="$v.tag.name.$dirty? !$v.tag.name.$error : null">
                                    </b-form-input>
                                    <b-form-invalid-feedback id="codeFeedback">
                                        Vui lòng nhập tên tag
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        
                        <b-row>
                            <b-col>
                                <b-form-group label="" :label-cols="4">
                                    <b-button v-if="authorize(['ManageTag'])" type="submit" variant="primary">Ghi lại</b-button>
                                    <b-button type="button" variant="secondary" @click="cancel">Hủy</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { validationMixin } from 'vuelidate'
    import { authorizationMixin } from '@/shared/mixins'
    import { required, sameAs, minLength, maxLength, helpers } from 'vuelidate/lib/validators'

    export default {
        name: 'Createtag',
        mixins: [validationMixin, authorizationMixin],
        data() {
            return {
                codeUnique: 'ok',
                tag: {
                    name: null,
                    url: null,
                    file: null,
                    displayOrder: null,
                    status: false
                },
                editing: false
            }
        },
        computed: {

        },
        validations: {
            tag: {
                name: {
                    required,
                    maxLength: maxLength(256)
                },
                code: {
                    required,
                    maxLength: maxLength(256)
                },
                //metaKeywords: {
                //    maxLength: maxLength(256)
                //},
                //metaDescriptions: {
                //    maxLength: maxLength(256)
                //},
            },
        },
        watch: {
            //'tag.code'(newVal) {
            //    this.checkExistCode(newVal);
            //}
        },
        created() {
        },
        methods: {
            cancel() {
                this.$router.push({ path: '/master-data/tags/list' });
            },
            save() {
                this.$v.$touch();
                var vm = this;
                if (!this.$v.$invalid) {
                    this.$services.post('master-data/tags', this.tag).done((id) => {
                        vm.$toastr.s('Tạo mới tag thành công');
                        vm.cancel();
                    });
                }
            },

            //checkExistCode(newVal) {
            //    if (newVal) {
            //        //var vm = this;
            //        //this.$services.get(`master-data/existing-unit-types-code/${newVal}/${this.tag.id || null}`).done(returnData => {
            //        //    if (!returnData) {
            //        //        this.codeUnique = "required";
            //        //    }
            //        //    else {
            //        //        this.codeUnique = "";
            //        //    }
            //        //});
            //    }
            //    else {
            //        this.codeUnique = "required";
            //    }
            //}
        }
    }

</script>
<style scoped>
</style>
